import type { RoomOccupancy } from '@/domain/shared/types'

import { useIntl } from '@/intl'

import Room from '@/scopes/common/components/Filters/Participants/Room'
import RoomNew from '@/scopes/common/components/Filters/Participants/RoomNew'
import { useDecision } from '@optimizely/react-sdk'

import { Button, Icon, tk } from '@sunwebgroup/ui-components'
import React, { Fragment } from 'react'
import { css, styled } from 'styled-components'
import { useRoomsParticipantsDistributionStore } from './useParticipantsStore'

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;

  @media ${tk('mq_mobile')} {
    padding: ${tk('spacing_lg')} ${tk('spacing_lg')} 0;
  }

  @media ${tk('mq_desktop_sm')} {
    width: 340px;
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
`

export const Footer = styled.div`
  padding: ${tk('spacing_md')} ${tk('spacing_lg')};
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tk('color_semantic_bg')};
  z-index: 1;
`

export const BannerWrapper = styled.div<{ $isSheet?: boolean }>`
  width: 100%;
  z-index: 2;
  position: sticky;
  display: flex;
  top: 0;
  left: 0;
  height: max-content;
  background: ${tk('color_semantic_bg')};
  padding-top: ${tk('spacing_lg')};
  margin-bottom: -${tk('spacing_sm')};

  ${({ $isSheet }) =>
    $isSheet
      ? css`
          @media ${tk('mq_desktop_md')} {
            width: 340px;
          }
        `
      : css`
          @media ${tk('mq_tablet')} {
            width: 340px;
          }
        `}
`

export const DialogBannerWrapper = styled(BannerWrapper)`
  max-width: unset;
  margin-top: ${tk('spacing_sm')};
  margin-bottom: 0;
  margin-left: 0;
  padding-top: 0;
`

// Hardcoded for now, this should come from sitecore
const MAX_ROOMS = 10

export function Body({ isMultiRoom = true, className }: { isMultiRoom?: boolean, className?: string }) {
  const intl = useIntl()
  const { roomsParticipantDistribution, addRoom } = useRoomsParticipantsDistributionStore()
  const [groupChildrenCategoriesDecision] = useDecision('ID_407_group_children_categories_in_quick_search')
  const groupChildrenCategories = groupChildrenCategoriesDecision?.enabled || false
  const maxRoomLimitReached = roomsParticipantDistribution.length >= MAX_ROOMS
  return (
    <Content className={className}>
      {roomsParticipantDistribution.map((_: RoomOccupancy, roomIndex: number) => (
        <Fragment key={roomIndex}>
          {groupChildrenCategories ? (<RoomNew roomIndex={roomIndex} />) : (<Room roomIndex={roomIndex} />)}
        </Fragment>
      ))}
      {isMultiRoom && (
        <Button
          $hierarchy="tertiary"
          $withoutColor
          disabled={maxRoomLimitReached}
          onClick={addRoom}
          data-qa="add-room-button"
        >
          <Icon glyph="IconPlus" />
          {intl.formatMessage({
            id: 'quicksearch_filter_participants_add_room',
          })}
        </Button>
      )}
    </Content>
  )
}
